import { SxProps, Theme } from '@mui/system';

const classes = {
  root: {
    display: 'flex',
    flexDirection: 'column',
  },

  container: {
    width: '100%',
    maxHeight: '440px',
    overflowY: 'auto',
    '&.MuiList-root': {
      paddingTop: '3px',
      paddingBottom: '3px',
    },
  },

  emptyContainer: {
    minHeight: 200,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },

  skeletonContainer: {
    minHeight: '80px',
    display: 'flex',
    padding: '10px',
  },

  skeletonAvatar: {
    width: 50,
    height: 50,
  },

  skeletonTextcontainer: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },

  skeletonText: {
    marginLeft: '8px',
  },

  notificationHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    p: '14px 14px 10px 16px',
    alignItems: 'center',
  },

  notificationTitle: { fontSize: 14, fontWeight: '600' },

  notificationSubContainer: { display: 'flex', alignItems: 'center', justifyContent: 'center' },

  notificationButtons: { fontSize: 12, padding: 0 },

  markReadButton: {
    marginRight: '16px',
  },

  enabledMenu: {
    color: 'primary.main',
  },

  disabledMenu: {
    color: 'common.grey350',
  },

  headerItems: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
} satisfies Record<string, SxProps<Theme>>;

export default classes;
